import { render, staticRenderFns } from "./RecordPrivacyToggle.vue?vue&type=template&id=509bba7c&scoped=true"
import script from "./RecordPrivacyToggle.vue?vue&type=script&lang=js"
export * from "./RecordPrivacyToggle.vue?vue&type=script&lang=js"
import style0 from "./RecordPrivacyToggle.vue?vue&type=style&index=0&id=509bba7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509bba7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
